import { render, staticRenderFns } from "./PortalLinks.vue?vue&type=template&id=de88caee&"
import script from "./PortalLinks.vue?vue&type=script&lang=js&"
export * from "./PortalLinks.vue?vue&type=script&lang=js&"
import style0 from "./PortalLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports